import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import PageHeader from "../../components/PageHeader";
import ListAltIcon from "@material-ui/icons/ListAlt";

import View from "./View";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  container: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),

    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const AuctionListView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Auction List"
    >
      <Container
        maxWidth="lg"
        className={classes.container}
      >

        <PageHeader
          icon={<ListAltIcon />}
          title="Auction Details"
          subtitle="Manage the information and settings for this auction."
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>

      </Container>
    </Page>
  );
};

export default AuctionListView;